import styled from 'styled-components';
import { MemberCheckModuleLoader } from '@pass-frontend/features/facility-checkin/data-bridge';
import { RdsLink } from '@pass-frontend/rally-energon-react';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';
import { CodeLookup } from '../code-lookup/code-lookup';
import { EligibilityLookup } from '../eligibility-lookup/eligibility-lookup';
import { FacilityHeader } from '../facility-header/facility-header';

const WidthConstrainer = styled.div`
  max-width: 1272px;
  margin: 0 auto;

  ${RESPONSIVE_QUERY.large} {
    width: 90%;
  }
`;

const SecondaryHeader = styled.div`
  text-align: left;

  ${RESPONSIVE_QUERY.medium} {
    text-align: center;
  }
`;

const WhiteBoxes = styled.div`
  ${RESPONSIVE_QUERY.medium} {
    flex-direction: column;
  }
`;

const Divider = styled.hr`
  ${RESPONSIVE_QUERY.medium} {
    display: none;
  }
`;

const LeftBox = styled.div`
  width: 100%;
`;

const RightBox = styled.div`
  max-width: 408px;

  ${RESPONSIVE_QUERY.medium} {
    max-width: 100%;
  }

  .right-box-content {
    ${RESPONSIVE_QUERY.medium} {
      margin-left: 0px;
    }
  }
`;

/* eslint-disable-next-line */
export interface FeaturesFacilityCheckinUiProps {}

export function FacilityCheckin(props: FeaturesFacilityCheckinUiProps) {
  return (
    <>
      <FacilityHeader />
      <div className="has-rds-mb-40">
        <div className="has-rds-bg-grey-lightest has-rds-pb-64">
          <WidthConstrainer className="has-rds-pv-40">
            <SecondaryHeader>
              <h2 className="is-rds-h2 has-rds-pb-8 has-rds-font-weight-semibold">
                Help members get access to your services!
              </h2>
              <p className="is-rds-body-1 has-rds-font-weight-medium">
                When members present their Renew Active®, One Pass™, or Aaptiv
                code, they'll get access to your fitness location depending on
                the tier level they have access to.
              </p>
            </SecondaryHeader>
            <Divider className="has-rds-mt-32 has-rds-mb-8" />
            <WhiteBoxes className="is-flex is-justify-content-center">
              <LeftBox>
                <MemberCheckModuleLoader>
                  <CodeLookup />
                  <EligibilityLookup />
                </MemberCheckModuleLoader>
              </LeftBox>
              <RightBox>
                <div className="right-box-content has-rds-ml-24">
                  <div>
                    <div className="has-rds-mb-16 has-rds-mt-24 is-rds-h6 rds-font-weight-medium">
                      Not in our partner network yet?
                    </div>
                  </div>
                  <div className="small-box has-rds-bg-white has-rds-p-24 has-rds-radius-4 has-rds-box-shadow-neutral-spread-6">
                    <div className="is-rds-body-2 has-rds-font-weight-medium has-rds-mb-16">
                      Become a participating fitness location
                    </div>
                    <p className="is-rds-body-3 has-rds-font-weight-semibold">
                      Join our dynamic health and wellness program network that
                      serves Medicare, Medicaid, and commercial members.
                      Complete the form below and someone from our team will
                      follow up.
                    </p>
                    <RdsLink
                      variant="heading"
                      className="rds-link-inline:hover rds-primary-button is-white-labeled-btn"
                      // Todo: add this link to env vars and neptune deploy -  PASS-2439
                      href="https://fitnessnetwork.my.site.com/WebsiteNominationGovernment/"
                    >
                      Get Started
                    </RdsLink>
                  </div>
                </div>
              </RightBox>
            </WhiteBoxes>
          </WidthConstrainer>
        </div>
      </div>
    </>
  );
}

export default FacilityCheckin;
